<template>
	<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="knowledgetree"
			:collapse="false" @item-click="itemClick" v-if="knowledgetree.length!=0"></v-jstree>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {
			field: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				loading: false,
				knowledgelist: [],
				knowledgetree: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.knowledgelist = []
				this.$api.knowledgelist.list({
					field: this.field
				}).then((res) => {
					let list = res
					res.forEach((item) => {
						item.icon = ''
					})
					let root = []
					list.forEach((item) => {
						if (!item.parentid) {
							root.push(item)
						} else {
							list.forEach((_item) => {
								if (item.parentid == _item.id) {
									if (!_item.children) {
										_item.children = []
									}
									_item.children.push(item)
								}
							})
						}
					})
					this.knowledgetree = root.length == 0 ? list : root
					this.knowledgelist = res
					this.loading = false

				})
			},
			itemClick(node, item, e) {
				this.currentObj = node
				this.currentItem = item
				
				let parentbread = [{
					id: item.id,
					name: item.name
				}]
				this.createParenBread(item, parentbread)
				//console.log(bread)
				this.currentChildren = []
				this.findcildren([item.id])
				this.$emit('select', {
					id: item.id,
					name: item.name,
					field:item.field,
					component: item.component,
					controller: item.controller,
					parentbread: parentbread,
					children: this.currentChildren,
					toolbarbutton: item.toolbarbutton,
					operatebutton: item.operatebutton,
					listfield: item.listfield ? item.listfield.listfield : []
				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			createParenBread(item, bread) {
				if (item.parentid == 0) {
					return item
				} else {
					for (let i = 0; i < this.knowledgelist.length; i++) {
						if (item.parentid == this.knowledgelist[i].id) {
							bread.unshift({
								name: this.knowledgelist[i].name,
								id: this.knowledgelist[i].id
							})
							this.createParenBread(this.knowledgelist[i], bread)
						}
					}
				}
			},
			findcildren(moduleids) {
				let childrenid = []
				moduleids.forEach((moduleid) => {
					this.knowledgelist.forEach((item) => {
						if (item.parentid == moduleid) {
							childrenid.push(item.id)
						}
					})
				})
				if (childrenid.length != 0) {
					this.currentChildren = this.currentChildren.concat(childrenid)
					this.findcildren(childrenid)
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
		},
		components: {
			VJstree
		}
	}
</script>
